import { CommandProcessor, LoadingProcessor, HeightChangeProcessor, StateChangeProcessor, StateProcessor, ModalProcessor, StepperModalProcessor, ChecklistModalProcessor, NavbarProcessor, TranslateProcessor, ToastProcessor, ApplicationProcessor, SegmentProcessor, UserContextProcessor, PermissionsProcessor, AccountProcessor, ApplicationRequestProcessor2, UnauthorizedAccessProcessor, TenantProcessor, MediaProcessor, SharedToastsProcessor, RedirectProcessor, SidebarProcessor, LaunchDarklyProcessor, } from './processors';
import { EventAction } from './EventAction';
import { PROCESSOR_PREFIX as ARTIFICIAL_INTELLIGENCE_PREFIX, ArtificialIntelligenceEventProcessor, } from '../application/detail/ai/EventProcessor';
import { PROCESSOR_PREFIX as TENANT_PREFIX, TenantEventProcessor, } from '../application/tenant/EventProcessor';
import { DESK_EVENT_PREFIX } from 'modules/application/detail/attendance/EventProcessor';
import { DeskEventProcessor } from 'modules/application/detail/attendance/EventProcessor';
import { AlertProcessor } from './processors/AlertProcessor';
import { CreateApplicationProcessor } from './processors/CreateApplicationProcessor';
import { DeleteApplicationProcessor } from './processors/DeleteApplicationProcessor';
import { ShowBlipChatProcessor } from './processors/ShowBlipChatProcessor';
const BLIP_EVENT_PREFIX = 'blipEvent:';
export const catchAction = (a) => {
    const pieces = a.split(':');
    return pieces.splice(1, pieces.length).join(':');
};
export class EventReceiver {
    constructor() { }
    /**
     * Initialize EventReceiver by adding event listener
     */
    init() {
        this.handleOnReceiveMessage = this.onReceiveMessage.bind(this);
        window.addEventListener('message', this.handleOnReceiveMessage);
    }
    /**
     * Remove event listener that handle received messages
     */
    removeEventListener() {
        window.removeEventListener('message', this.handleOnReceiveMessage);
    }
    /**
     * Handle all message received from child applications
     * @param msgEvt - Message object received from eventListener
     */
    async onReceiveMessage(msgEvt) {
        const shouldHandleMessage = msg => Object.keys(msg).find(k => k == 'action' && msg.action.startsWith(BLIP_EVENT_PREFIX));
        if (!msgEvt.data ||
            !msgEvt.data.message ||
            !shouldHandleMessage(msgEvt.data.message)) {
            return;
        }
        const payload = {
            ...msgEvt.data,
            source: msgEvt.source,
        };
        const action = catchAction(payload.message.action);
        if (action.startsWith(TENANT_PREFIX)) {
            payload.message.action = action;
            return TenantEventProcessor.process(payload);
        }
        if (action.startsWith(ARTIFICIAL_INTELLIGENCE_PREFIX)) {
            payload.message.action = action;
            return ArtificialIntelligenceEventProcessor.process(payload);
        }
        if (action.startsWith(DESK_EVENT_PREFIX)) {
            payload.message.action = action;
            return DeskEventProcessor.process(payload);
        }
        switch (action) {
            case EventAction.SendCommand:
                await CommandProcessor.process(payload);
                break;
            case EventAction.StartLoading:
            case EventAction.StopLoading:
                LoadingProcessor.process(payload);
                break;
            case EventAction.HeightChange:
                HeightChangeProcessor.process(payload);
                break;
            case EventAction.State:
                StateProcessor.process(payload);
                break;
            case EventAction.StateChangeSuccess:
                StateChangeProcessor.process(payload);
                break;
            case EventAction.ShowModal:
                ModalProcessor.process(payload);
                break;
            case EventAction.ShowStepperModal:
                StepperModalProcessor.process(payload);
                break;
            case EventAction.ShowChecklistModal:
                ChecklistModalProcessor.process(payload);
                break;
            case EventAction.ShowOverlayAndBlockScroll:
                ModalProcessor.showOverlayAndBlockScroll(payload);
                break;
            case EventAction.RemoveOverlayAndReleaseScroll:
                ModalProcessor.removeOverlayAndReleaseScroll();
                break;
            case EventAction.HideNavbar:
            case EventAction.ShowNavbar:
            case EventAction.ChangeSubheaderTitle:
                NavbarProcessor.process(payload);
                break;
            case EventAction.GetCurrentLanguage:
                TranslateProcessor.process(payload);
                break;
            case EventAction.Toast:
                ToastProcessor.process(payload);
                break;
            case EventAction.GetApplication:
                ApplicationProcessor.process(payload);
                break;
            case EventAction.HasPermissions:
            case EventAction.GetPermissionsObject:
                PermissionsProcessor.process(payload);
                break;
            case EventAction.Segment:
                SegmentProcessor.process(payload);
                break;
            case EventAction.GetToken:
            case EventAction.GetAccount:
            case EventAction.InviteUser:
                AccountProcessor.process(payload);
                break;
            case EventAction.UserContext:
                UserContextProcessor.process(payload);
                break;
            case EventAction.SendApplicationRequest:
                ApplicationRequestProcessor2.process(payload);
                break;
            case EventAction.UnauthorizedAccess:
                UnauthorizedAccessProcessor.process();
                break;
            case EventAction.GetTenantUrl:
                TenantProcessor.process(payload);
                break;
            case EventAction.AddTenantPrefixToUrl:
                TenantProcessor.process(payload);
                break;
            case EventAction.GetTenantPlan:
                TenantProcessor.process(payload);
                break;
            case EventAction.UploadFile:
                MediaProcessor.process(payload);
                break;
            case EventAction.ShowUploadErrorToast:
                SharedToastsProcessor.process(payload);
                break;
            case EventAction.ShowAlert:
                AlertProcessor.process(payload);
                break;
            case EventAction.RedirectProcessor:
                RedirectProcessor.process(payload);
                break;
            case EventAction.RedirectToCreateAiAgent:
                RedirectProcessor.process(payload);
                break;
            case EventAction.RedirectToApplicationDetail:
                RedirectProcessor.process(payload);
                break;
            case EventAction.RedirectToJourney:
                RedirectProcessor.process(payload);
                break;
            case EventAction.CloseSidebar:
                SidebarProcessor.process(payload);
                break;
            case EventAction.LaunchDarkly:
                LaunchDarklyProcessor.process(payload);
                break;
            case EventAction.CreateApplication:
                await CreateApplicationProcessor.process(payload);
                break;
            case EventAction.DeleteApplication:
                await DeleteApplicationProcessor.process(payload);
                break;
            case EventAction.ShowBlipChat:
                await ShowBlipChatProcessor.process(payload);
                break;
            default:
                throw new Error(`Unrecognized EventReceiver action: '${payload.message.action}'`);
        }
    }
}
